import { render } from "./QuestionChooser.vue?vue&type=template&id=aec9cd32"
import script from "./QuestionChooser.vue?vue&type=script&lang=js"
export * from "./QuestionChooser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__